import axios from "../../axios";
import { ResponseModel, STATUS_OK } from '../../models/network/response_model'

import { GET_WORKING_HOUR , CREATE_BUSINESS_TIME_OFF , LIST_BUSINESS_BLOCK_TIME, LIST_STAFF_BLOCK_TIME , GET_BUSINESS_TIME_OFF, UPDATE_BUSINESS_TIME_OFF, DELETE_BUSINESS_TIME_OFF} from "./businessTypes";
import { WORKING_HOUR_URL , URL_CREATE_BUSINESS_TIME_OFF , URL_LIST_BLOCK_TIME , URL_GET_BUSINESS_TIME_OFF, URL_UPDATE_BUSINESS_TIME_OFF, URL_DELETE_BUSINESS_TIME_OFF} from "./businessUrls";

export default {
  [GET_WORKING_HOUR]({ commit }, params) {
    axios.get(WORKING_HOUR_URL, {
      params: params
    }).then((response) => {
      let responseModel = new ResponseModel(response);
      commit(GET_WORKING_HOUR, responseModel.result.data)
    });
  },

  // eslint-disable-next-line
  [CREATE_BUSINESS_TIME_OFF]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`${URL_CREATE_BUSINESS_TIME_OFF}`, item)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              if(item.type == 1) {
                dispatch(LIST_BUSINESS_BLOCK_TIME, {filterType: item.type, page: item.page, 'per-page': item['per-page']})
              } else {
                dispatch(LIST_STAFF_BLOCK_TIME, {filterType: item.type, filterStaffId: item.staff_id, page: item.page, 'per-page': item['per-page']})
              }
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [UPDATE_BUSINESS_TIME_OFF]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`${URL_UPDATE_BUSINESS_TIME_OFF}`, item)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              if(item.type == 1) {
                dispatch(LIST_BUSINESS_BLOCK_TIME, {filterType: item.type, page: item.page, 'per-page': item['per-page']})
              } else {
                dispatch(LIST_STAFF_BLOCK_TIME, {filterType: item.type, filterStaffId: item.staff_id, page: item.page, 'per-page': item['per-page']})
              }
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [DELETE_BUSINESS_TIME_OFF]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`${URL_DELETE_BUSINESS_TIME_OFF}`, item)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              if(item.type == 1) {
                dispatch(LIST_BUSINESS_BLOCK_TIME, {filterType: item.type, page: item.page, 'per-page': item['per-page']})
              } else {
                dispatch(LIST_STAFF_BLOCK_TIME, {filterType: item.type, filterStaffId: item.staff_id, page: item.page, 'per-page': item['per-page']})
              }
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [LIST_BUSINESS_BLOCK_TIME]({ commit }, item) {
    return new Promise((resolve, reject) => {
      let param = new URLSearchParams(item).toString();
      axios.get(`${URL_LIST_BLOCK_TIME}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(LIST_BUSINESS_BLOCK_TIME, data);
              resolve(data);
            } else {
              commit(LIST_BUSINESS_BLOCK_TIME, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(LIST_BUSINESS_BLOCK_TIME, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [LIST_STAFF_BLOCK_TIME]({ commit }, item) {
    return new Promise((resolve, reject) => {
      let param = new URLSearchParams(item).toString();
      axios.get(`${URL_LIST_BLOCK_TIME}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(LIST_STAFF_BLOCK_TIME, data);
              resolve(data);
            } else {
              commit(LIST_STAFF_BLOCK_TIME, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(LIST_STAFF_BLOCK_TIME, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_BUSINESS_TIME_OFF]({ commit }, item) {
    return new Promise((resolve, reject) => {
      let param = new URLSearchParams(item).toString();
      axios.get(`${URL_GET_BUSINESS_TIME_OFF}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_BUSINESS_TIME_OFF, data);
              resolve(data);
            } else {
              commit(GET_BUSINESS_TIME_OFF, {});
              resolve({});
            }
          } else {
            commit(GET_BUSINESS_TIME_OFF, {});
            resolve({});
          }
        })
        .catch((error) => { reject(error) })
    })
  },
}
